import { Button, Form, Input, Radio, Select } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
const ModalAddFees = ({ close }: any) => {
  const [price, setPrice] = useState();
  const [percent, setPercent] = useState();
  const [price2, setPrice2] = useState();
  const [percent2, setPercent2] = useState();
  const [selectedRadio, setSelectedRadio] = useState(null);
  const intl = useIntl();
  const { formatMessage } = intl;

  const onFinish = (values: any) => {
    let val;
    switch (values.price) {
      case "fixed":
        val = { value: price };
        break;
      case "percentage":
        val = { percent };
        break;
      case "both":
        val = { value: price2, percent: percent2 };
        break;
      default:
        val = { value: 0, percent: 0 };
    }

    console.log({ ...values, ...val });
  };
  const onChange = (value: string) => {
    console.log(`selected ${value}`);
  };
  const options = [
    {
      value: "1",
      label: "5",
    },
    {
      value: "2",
      label: "10",
    },
    {
      value: "3",
      label: "15",
    },
  ];

  const handleRadioChange = (e: any) => {
    setSelectedRadio(e.target.value);
  };
  return (
    <div>
      <div className="text-center lg:p-10">
        <div className="text-center">
          <h4 className="text-color-primary font-semibold text-2xl">
            <FormattedMessage id="title" />
          </h4>
          <p className="text-base text-[#75757E] mt-4">
            <FormattedMessage id="description" />
          </p>
        </div>
        <Form
          name="SaleGiftCard"
          onFinish={onFinish}
          layout={"vertical"}
          className="w-full flex flex-col items-center justify-center mt-8"
        >
          <div className="flex max-md:flex-col items-center gap-4 w-full">
            <Form.Item
              name={"name"}
              label={formatMessage({ id: "form_sale_gift_card_name_label" })}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: formatMessage({
                    id: "form_sale_gift_card_name_label",
                  }),
                },
              ]}
              required={false}
            >
              <Input
                className="w-full"
                placeholder={formatMessage({
                  id: "form_sale_gift_card_name_label",
                })}
              />
            </Form.Item>
            <Form.Item
              name={"description"}
              label={formatMessage({
                id: "form_sale_gift_card_description_label",
              })}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: formatMessage({
                    id: "form_sale_gift_card_description_label",
                  }),
                },
              ]}
              required={false}
            >
              <Input
                className="w-full"
                placeholder={formatMessage({
                  id: "form_sale_gift_card_description_label",
                })}
              />
            </Form.Item>
          </div>
          <Form.Item
            name={"fees"}
            label={
              <div className="font-semibold text-color-primary mb-4">
                {intl.formatMessage({ id: "fees_application_label" })}
              </div>
            }
            className="w-full p-4 rounded-lg bg-[#EEF0FF]"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "fees_required_message" }),
              },
            ]}
            required={false}
          >
            <Radio.Group className="w-full" onChange={handleRadioChange}>
              <div className="grid grid-cols-2 max-md:grid-cols-1 w-full gap-x-4 gap-2">
                <Radio
                  value={11}
                  className="py-3 px-4 rounded-lg md:col-span-2"
                >
                  <span className="w-full flex items-center justify-start">
                    {intl.formatMessage({
                      id: "fees_full_sale_process_option",
                    })}
                  </span>
                </Radio>
                <Radio
                  value={1}
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  {intl.formatMessage({ id: "fees_services_only_option" })}
                </Radio>
                <Radio
                  value={2}
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  {intl.formatMessage({ id: "fees_products_only_option" })}
                </Radio>
                <Radio
                  value={3}
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  {intl.formatMessage({ id: "fees_gift_cards_only_option" })}
                </Radio>
                <Radio
                  value={4}
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  {intl.formatMessage({ id: "fees_memberships_only_option" })}
                </Radio>
              </div>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name={"price"}
            label={
              <div className="font-semibold text-color-primary mb-4">
                {intl.formatMessage({ id: "priceLabel" })}
              </div>
            }
            className="w-full p-4 pb-0 rounded-lg bg-[#EEF0FF]"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "priceErrorMessage" }),
              },
            ]}
            required={false}
          >
            <Radio.Group className="w-full" onChange={handleRadioChange}>
              <div className="grid grid-cols-2 max-lg:grid-cols-1 w-full gap-x-4 gap-2">
                <Radio
                  value="fixed"
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  <div className="flex items-center justify-between w-full">
                    <span>{intl.formatMessage({ id: "priceFixed" })}</span>
                    <Input
                      suffix={
                        <div className="text-color-primary font-semibold">
                          ر.س
                        </div>
                      }
                      className="max-w-[100px] justify-self-end"
                      onChange={(e: any) => setPrice(e.target.value)}
                      value={price}
                      disabled={selectedRadio !== "fixed"}
                      type="number"
                    />
                  </div>
                </Radio>
                <Radio
                  value="percentage"
                  className="bg-white w-full py-3 px-4 rounded-lg"
                >
                  <div className="flex items-center justify-between w-full">
                    <span>{intl.formatMessage({ id: "percentage" })}</span>
                    <Input
                      suffix={
                        <div className="text-color-primary font-semibold">
                          %
                        </div>
                      }
                      className="max-w-[100px] justify-self-end"
                      onChange={(e: any) => setPercent(e.target.value)}
                      value={percent}
                      disabled={selectedRadio !== "percentage"}
                      type="number"
                    />
                  </div>
                </Radio>
                <Radio
                  value={"both"}
                  className=" w-full py-3 rounded-lg lg:col-span-2"
                >
                  <div className="flex max-lg:flex-col items-center justify-between w-full">
                    <span className="max-lg:mb-2">
                      {intl.formatMessage({ id: "both" })}
                    </span>
                    <div className="flex items-center gap-4">
                      <Input
                        suffix={
                          <div className="text-color-primary font-semibold">
                            ر.س
                          </div>
                        }
                        className="max-w-[100px] justify-self-end"
                        onChange={(e: any) => setPrice2(e.target.value)}
                        value={price2}
                        disabled={selectedRadio !== "both"}
                        type="number"
                      />
                      <Input
                        suffix={
                          <div className="text-color-primary font-semibold">
                            %
                          </div>
                        }
                        className="max-w-[100px] justify-self-end"
                        onChange={(e: any) => setPercent2(e.target.value)}
                        value={percent2}
                        disabled={selectedRadio !== "both"}
                        type="number"
                      />
                    </div>
                  </div>
                </Radio>
              </div>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name={"values"}
            label={
              <div className="font-semibold text-color-primary mb-4">
                {intl.formatMessage({ id: "taxValueLabel" })}
              </div>
            }
            className="w-full p-4 rounded-lg bg-[#EEF0FF] "
            // rules={[{ required: true, message: intl.formatMessage({ id: 'taxValueErrorMessage' }) }]}
            required={false}
          >
            <div className="flex items-center justify-between">
              <span>{intl.formatMessage({ id: "selectTax" })}</span>
              <span>
                <Form.Item name="taxValue" noStyle>
                  <Select
                    optionFilterProp="children"
                    className="min-w-[100px]"
                    defaultValue="5" // Set the default value here if needed
                    onChange={onChange}
                    options={options}
                  />
                </Form.Item>
              </span>
            </div>
          </Form.Item>
          <div className="flex items-center gap-4 w-full">
            <Button type="primary" htmlType="submit" className=" w-full">
              {formatMessage({ id: "form_sale_gift_card_add_button_label" })}
            </Button>
            <Button
              type="primary"
              className="btn-primary-not w-full"
              onClick={close}
            >
              {formatMessage({ id: "form_sale_gift_card_cancel_button_label" })}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ModalAddFees;
